import {DateTimeFormatter} from 'js-joda'
import Table from 'material-ui-next/Table/Table'
import TableBody from 'material-ui-next/Table/TableBody'
import TableCell from 'material-ui-next/Table/TableCell'
import TableHead from 'material-ui-next/Table/TableHead'
import TableRow from 'material-ui-next/Table/TableRow'
import AppBar from 'material-ui/AppBar'
import Checkbox from 'material-ui/Checkbox'
import FlatButton from 'material-ui/FlatButton'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import IconButton from 'material-ui/IconButton'
import ActionAccountBox from 'material-ui/svg-icons/action/account-box'
import ActionDone from 'material-ui/svg-icons/action/done'
import ContentAdd from 'material-ui/svg-icons/content/add'
import ContentClear from 'material-ui/svg-icons/content/clear'
import FileFileDownload from 'material-ui/svg-icons/file/file-download'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu'
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh'
import * as React from 'react'
import injectSheet from 'react-jss'
import {url} from '../../App/AuthenticatedRoute'
import {OrderFilterContainer} from '../../Components/OrderFiltering/OrderFilteringView'
import {formatPrice} from '../../Data/NumberHelper'
import {Pagination} from '../../Data/Pagination'
import {OrderWithOwners} from '../../Entities/OrderWithOwners'
import * as ShippingMethod from '../../Entities/ShippingMethod'
import {layers} from '../../Style'
import creiosTheme from '../../Theme/creiosTheme'
import {AppBarSearch} from '../../View/AppbarSearch'
import {Footer} from '../../View/Footer'
import {LinkTableCell} from '../../View/LinkTableCell'
import {PageSize} from '../../View/PageSize'
import {PaginationView} from '../../View/PaginationView'
import {OrderOverviewAction} from './OrderOverviewActions'
import {OrderOverviewState} from './OrderOverviewState'

const styles = {
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    overviewWrapper: {
        overflowY: 'scroll',
        flex: '1'
    },
    navigationBar: {
        height: '128px'
    },
    actionButton: {
        position: 'absolute',
        right: '44px',
        top: '100px',
        zIndex: layers.front
    },
}

interface Props {
    readonly state: OrderOverviewState
    readonly dispatch: (action: OrderOverviewAction) => void
}

export const OrderOverview =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch}) => {
            return (
                <div className={classes.root}>
                    <div className="navigation">
                        <AppBar
                            title="Auftragsübersicht"
                            className={classes.navigationBar}
                            iconElementLeft={
                                <IconButton
                                    onTouchTap={() =>
                                        dispatch({
                                            type: 'MenuButtonClicked',
                                        })}
                                >
                                    <NavigationMenu/>
                                </IconButton>}
                            iconElementRight={
                                <div className="nav-icon-element_right">
                                    <FlatButton
                                        label="Export"
                                        icon={
                                            <FileFileDownload color={'#fff'}/>}
                                        href={url({type: 'OrderExportOverview'})}
                                        labelStyle={{color: '#fff'}}
                                    />
                                    <AppBarSearch/>
                                </div>
                            }
                        />

                        <FloatingActionButton
                            className={classes.actionButton}
                            href={url({type: 'OrderCreate'})}
                        >
                            <ContentAdd/>
                        </FloatingActionButton>
                    </div>
                    <div className={`overview ${classes.overviewWrapper}`}>
                        <div
                            className="overview__content"
                        >
                            <OrderFilterContainer
                                state={state.orderFilter}
                                dispatch={
                                    subAction => dispatch(
                                        {
                                            type: 'OrderFilteringModuleAction',
                                            subAction,
                                        }
                                    )
                                }
                            />
                            <OrderTable
                                orders={state.orders.data}
                                dispatch={dispatch}
                            />
                        </div>
                    </div>
                    <OrderOverviewFooter
                        orders={state.orders}
                        dispatch={dispatch}
                    />
                </div>)
        }
    )

function OrderTable({orders, dispatch}: {
    orders: OrderWithOwners[],
    dispatch: (action: OrderOverviewAction) => void,
}) {
    return (
        <Table className="overview__table data-table">
            <TableHead>
                <TableRow>
                    <TableCell className="overview__table-ordernumber">
                        Auftrag
                    </TableCell>
                    <TableCell className="overview__table-customer">
                        Kunde
                    </TableCell>
                    <TableCell>
                        Gesellschaft
                    </TableCell>
                    <TableCell>
                        Besteller
                    </TableCell>
                    <TableCell>
                        Datum
                    </TableCell>
                    <TableCell className="overview__table-extra">
                        Extra
                    </TableCell>
                    <TableCell>
                        Versand
                    </TableCell>
                    <TableCell>
                        Bestellnr.
                    </TableCell>
                    <TableCell style={{textAlign: 'right'}}>
                        Preis (Netto)
                    </TableCell>
                    <TableCell className="overview__table-paid">
                        Bezahlt
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {orders.map((orderWithOwners: OrderWithOwners) =>
                    <OrderRow
                        orderWithOwners={orderWithOwners}
                        dispatch={dispatch}
                        key={orderWithOwners.order.id}
                    />)}
            </TableBody>
        </Table>)
}

function OrderRow({orderWithOwners, dispatch}: {
    orderWithOwners: OrderWithOwners,
    dispatch: (action: OrderOverviewAction) => void,
}) {
    const {order, bpsUser, customer, company} = orderWithOwners
    const href = url({type: 'OrderDetails', orderNumber: order.orderNumber})
    return (
        <TableRow>
            <LinkTableCell href={href}>
                {order.orderNumber}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {customer.longName}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {company.name1} {company.name2}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {bpsUser.lastName}, {bpsUser.firstName}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {order.created.format(DateTimeFormatter.ISO_LOCAL_DATE_TIME)}
            </LinkTableCell>
            <LinkTableCell href={href}>
                <ActionAccountBox/>
            </LinkTableCell>
            <LinkTableCell href={href}>
                {ShippingMethod.label(order.shippingMethod)}
            </LinkTableCell>
            <LinkTableCell href={href}>
                {order.transactionNumber}
            </LinkTableCell>
            <LinkTableCell
                href={href}
                numeric={true}
            >
                {formatPrice(order.netPrice)}
            </LinkTableCell>
            <TableCell className="overview__table-paid">
                {(() => {
                    switch (order.orderPaid) {
                        case 'Unpaid':
                            return (
                                <OrderPaidCheckbox
                                    orderId={order.id}
                                    paid={false}
                                    dispatch={dispatch}
                                />
                            )
                        case 'Paid':
                            return (
                                <OrderPaidCheckbox
                                    orderId={order.id}
                                    paid={true}
                                    dispatch={dispatch}
                                />
                            )
                        case 'Credited':
                            return <NavigationRefresh/>
                    }
                })()}
            </TableCell>
        </TableRow>
    )
}

function OrderPaidCheckbox({orderId, paid, dispatch}: {
    orderId: number,
    paid: boolean,
    dispatch: (action: OrderOverviewAction) => void,
}) {
    return (
        <Checkbox
            checked={paid}
            checkedIcon={
                <ActionDone
                    style={{fill: creiosTheme.palette.successColor}}
                />}
            uncheckedIcon={
                <ContentClear
                    style={{fill: creiosTheme.palette.errorColor}}
                />}
            onCheck={(event: React.MouseEvent<{}>, checked: boolean) =>
                dispatch({
                    type: 'OrderPaidChanged',
                    orderId,
                    checked,
                })}
        />

    )
}

function OrderOverviewFooter({orders, dispatch}: {
    orders: Pagination<OrderWithOwners>
    dispatch: (action: OrderOverviewAction) => void,
}) {
    return (
        <Footer>
            <PageSize
                itemsPerPage={orders.pageSection.itemsPerPage}
                onChange={
                    value => dispatch({
                        type: 'ItemsPerPageChanged',
                        value,
                    })
                }
            />
            <PaginationView
                pagination={orders}
                onNavigate={navigation => dispatch({
                    type: 'PaginationNavigation',
                    navigation
                })}
            />
        </Footer>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderOverview/OrderOverviewView.tsx